import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Temporarily disable StrictMode in development to avoid duplicate effects
// Re-enable for production builds
const AppWrapper = process.env.NODE_ENV === 'development' ? 
  ({ children }) => children : 
  React.StrictMode;

root.render(
  <AppWrapper>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <ToastContainer position="top-right" autoClose={3000} />
      </BrowserRouter>
    </Provider>
  </AppWrapper>
);
